import {DialogActions, DialogContent, DialogTitle} from "@mui/material";
import Button from "@mui/material/Button";
import React, {useEffect, useState} from "react";
import FileUpload from "../../components/fileUpload";
import {
    AddLegalCaseDTO,
    AddLitigantToCaseDTO,
    CaseType,
    CompanyDTO,
    CourtType,
    CurrencyType,
    EditLegalCaseDTO,
    getPresentableCaseTypeCourtName,
    getPresentableCurrencyType,
    LegalCaseDTO,
    LegalCaseStatus,
    SettingsLookupDTO,
    UserRole
} from "../../api/dtos";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import {LocalizationProvider} from '@mui/x-date-pickers';
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {AppState} from "../../store";
import {
    getAllClientsAction,
    getAllCommitteesAction,
    getAllCompaniesAction,
    getAllCourtHousesAction,
    getAllCourtsAction,
    getAllNotariesAction,
    getLoadCitiesAction
} from "../../api/settings";
import {createLegalCaseAction, editLegalCaseAction, getLegalCasesAction} from "../../api/legalCase";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import moment from "moment";
import Chip from "@mui/material/Chip";
import {styled} from "@mui/material/styles";
import AddIcon from '@mui/icons-material/Add';
import Fab from "@mui/material/Fab";
import {AddProsecutorDialog} from "./addProsecutorDialog";
import {AddDefendantsDialog} from "./addDefendantsDialog";
import {AddReportedEntitiesDialog} from "./addReportedEntitiesDialog";
import {DatePicker} from '@mui/x-date-pickers/DatePicker'
import {TextFieldVariants} from "@mui/material/TextField/TextField";
import {AddTrialDateDialog} from "./addTrialDateDialog";
import {v4 as uuidv4} from 'uuid';
import {
    setAllCitiesLookup,
    setAllClientsLookup,
    setAllCompanies,
    setAllCourtHouses,
    setAllCourts
} from "../../features/settings/settingsSlice";
import {LitigantType} from "../../api/litigantType";
import OutlinedInput from "@mui/material/OutlinedInput";
import {AsyncTaskStatusType, FieldErrors} from "../../shared/dtos";
import ErrorText from "../../components/ErrorText";
import {setCreateLegalCaseTaskStatus} from "../../features/legal-case/legalCaseSlice";
import {tr} from 'date-fns/locale';
import {getAllUsersAction} from "../../api/appUser";
import CustomDialog from "../../components/CustomDialog";
import {Autocomplete} from "@mui/lab";
import {CreateCommitteeDialog} from "../create-committee/createCommitteeDialog";
import {CreateNotaryDialog} from "../create-notary/createNotaryDialog";
import {CreateCourt} from "../create-court/createCourtDialog";

export interface AddLitigantType {
    litigantType: LitigantType;
    selection?: CompanyDTO | SettingsLookupDTO;
    name?: string;
}

interface CreateLegalCaseDialogProps {
    handleClose: () => void;
    onAddLegalCase: () => void;
    page: number;
    caseType: CaseType;
    legalCase: LegalCaseDTO | null;
}

interface AddCreateLegalCaseFormData {
    file: string | null;
    name: string;
    fileNumber: string;
    corporateFileNumber: string;
    investigationDate: string;
    prosecutors: AddLitigantToCaseDTO[];
    defendants: AddLitigantToCaseDTO[];
    reportedEntities: AddLitigantToCaseDTO[];
    caseDate: Date;
    cityId: number | null;
    courtId: number | null;
    courtHouseId: number | null;
    caseType: CaseType;
    status: LegalCaseStatus;
    trialDates: string[];
    responsibleIds: number[];
    appeal: string | null;
    note: string | null;
    notaryId: number | null;
    committeeId: number | null;
    amount: number;
    currencyType: CurrencyType;
}

const fieldVariant = "outlined"

export const CreateLegalCaseDialog: React.FC<CreateLegalCaseDialogProps> = ({
                                                                                handleClose,
                                                                                legalCase,
                                                                                onAddLegalCase,
                                                                                caseType,
                                                                                page
                                                                            }) => {
    const createLegalCaseTaskStatus = useSelector((state: AppState) => state.legalCase.createLegalCaseTaskStatus);
    const allClientsLookup = useSelector((state: AppState) => state.settings.allClientsLookup);
    const allCompanies = useSelector((state: AppState) => state.settings.allCompanies);
    const editMode = !!legalCase;
    const [addTrialDatesDialogIsOpen, setAddTrialDatesDialogIsOpen] = useState(false);
    const [createCommitteeDialogIsOpen, setCreateCommitteeDialogIsOpen] = useState(false);
    const [createNotaryDialogIsOpen, setCreateNotaryDialogIsOpen] = useState(false);
    const [createCourtDialogIsOpen, setCreateCourtDialogIsOpen] = useState(false);
    const [selectedCourt, setSelectedCourt] = useState<number | null>(null);

    const getCreateCourtCourtType = () => {
        switch (caseType) {
            case CaseType.Idari:
                return CourtType.IdareMahkemeleri;
            case CaseType.Hukuk:
                return CourtType.HukukMahkemeleri;
            case CaseType.Icra:
                return CourtType.IcraMahkemeleri;
            case CaseType.Ceza:
                return CourtType.CezaMahkemeleri;
            case CaseType.Sorusturma:
                return CourtType.Savcilik;
            case CaseType.IcraTakip:
                return CourtType.IcraDaireleri;
            default:
                return CourtType.HukukMahkemeleri;
        }
    }

    const [usedCourtType, setUsedCourtType] = useState<CourtType | null>(getCreateCourtCourtType());

    const handleCreateCourtDialogOpen = (selectedCourtHouseId: number | null) => {
        setCreateCourtDialogIsOpen(true);
        setFormData((prevFormData) => ({
            ...prevFormData,
            courtHouseId: selectedCourtHouseId,
        }));
    };

    const getCourtTypeToCaseType = (caseType: CaseType): CourtType => {
        switch (caseType) {
            case CaseType.Idari:
                return CourtType.IdareMahkemeleri;
            case CaseType.Hukuk:
                return CourtType.HukukMahkemeleri;
            case CaseType.Icra:
                return CourtType.IcraMahkemeleri;
            case CaseType.Ceza:
                return CourtType.CezaMahkemeleri;
            case CaseType.Sorusturma:
                return CourtType.Savcilik;
            case CaseType.IcraTakip:
                return CourtType.IcraDaireleri;
            default:
                return CourtType.HukukMahkemeleri;
        }
    };

    const getCourtDialogProps = () => {
        switch (caseType) {
            case CaseType.Hukuk:
            case CaseType.Ceza:
            case CaseType.Sorusturma:
            case CaseType.Icra:
                return {
                    isCourtTypeDisabled: true,
                    allowedCourtTypes: [
                        getCourtTypeToCaseType(caseType)
                    ],
                };
            case CaseType.Idari:
                return {
                    isCourtTypeDisabled: false,
                    allowedCourtTypes: [
                        CourtType.IdareMahkemeleri,
                        CourtType.VergiMahkemeleri
                    ],
                };
            default:
                return {
                    isCourtTypeDisabled: false,
                    allowedCourtTypes: undefined,
                };
        }
    };

    const handleCreateCourtDialogClose = () => setCreateCourtDialogIsOpen(false);

    const handleAddCourt = (cityId: number, courtHouseId: number) => {
        dispatch(getAllCourtsAction()).then(() => {
            const courts = allCourts?.filter(c => c.courtHouse.city.plateId === cityId && c.courtHouse.id === courtHouseId);
            if (courts && courts.length > 0) {
                const lastCourt = courts[courts.length - 1];
                setFormData(prev => ({
                    ...prev,
                    courtId: lastCourt.id
                }));
                setSelectedCourt(lastCourt.id);
            }
            handleCreateCourtDialogClose();
        });
    };

    const handleCreateCommitteeDialogClose = () => setCreateCommitteeDialogIsOpen(false);
    const handleCreateCommitteeDialogOpen = () => setCreateCommitteeDialogIsOpen(true);

    const handleCreateNotaryDialogOpen = () => setCreateNotaryDialogIsOpen(true);
    const handleCreateNotaryDialogClose = () => setCreateNotaryDialogIsOpen(false);

    const handleCreateCommittee = () => {
        dispatch(getAllCommitteesAction());
        handleCreateCommitteeDialogClose();
    }

    const handleCreateNotary = () => {
        dispatch(getAllNotariesAction());
        handleCreateNotaryDialogClose();
    }

    const handleAddTrialDatesDialogOpen = () => setAddTrialDatesDialogIsOpen(true);
    const handleAddTrialDatesDialogClose = () => setAddTrialDatesDialogIsOpen(false);

    const [addProsecutorDialogIsOpen, setAddProsecutorDialogIsOpen] = useState(false);

    const handleAddProsecutorDialogOpen = () => setAddProsecutorDialogIsOpen(true);
    const handleAddProsecutorDialogClose = () => setAddProsecutorDialogIsOpen(false);

    const [trialDatesChipData, setTrialDatesChipData] = React.useState<readonly ChipData[]>([]);

    const [addDefendantsDialogIsOpen, setAddDefendantsDialogIsOpen] = useState(false);

    const handleAddDefendantsDialogOpen = () => setAddDefendantsDialogIsOpen(true);
    const handleAddDefendantsDialogClose = () => setAddDefendantsDialogIsOpen(false);

    const [addReportedEntitiesDialogIsOpen, setAddReportedEntitiesDialogIsOpen] = useState(false);

    const handleAddReportedEntitiesDialogOpen = () => setAddReportedEntitiesDialogIsOpen(true);
    const handleAddReportedEntitiesDialogClose = () => setAddReportedEntitiesDialogIsOpen(false);

    const navigate = useNavigate();
    const dispatch: any = useDispatch();
    const allCourtHouses = useSelector((state: AppState) => state.settings.allCourtHouses);
    const allCourts = useSelector((state: AppState) => state.settings.allCourts);
    const allCitiesLookup = useSelector((state: AppState) => state.settings.allCitiesLookup);
    const allUsersLookup = useSelector((state: AppState) => state.appUser.allUsersLookup);
    const user = useSelector((state: AppState) => state.auth.userWithToken?.user);
    const allCommittees = useSelector((state: AppState) => state.settings.allCommittees);
    const allNotaries = useSelector((state: AppState) => state.settings.allNotaries);

    useEffect(() => {
        dispatch(getAllClientsAction());
        dispatch(getAllCourtHousesAction());
        dispatch(getAllCourtsAction());
        dispatch(getLoadCitiesAction());
        dispatch(getAllUsersAction());
        dispatch(getAllNotariesAction());
        dispatch(getAllCommitteesAction());

        if (editMode) {
            dispatch(getAllCompaniesAction());
        }

        return () => {
            dispatch(setAllClientsLookup(null));
            dispatch(setAllCourtHouses(null));
            dispatch(setAllCompanies(null));
            dispatch(setAllCourts(null));
            dispatch(setAllCitiesLookup(null));
            dispatch(setCreateLegalCaseTaskStatus(null));
        }
    }, [dispatch]);

    const cityHolder = legalCase?.type === CaseType.Ihtarname
        ? legalCase.notary
        : legalCase?.type === CaseType.TuketiciHakemHeyeti
            ? legalCase.committee
            : legalCase?.court?.courtHouse;

    const getLitigantName = (id: number, type: LitigantType) => {
        return (type === LitigantType.Client
            ? allClientsLookup?.find(c => c.id === id)?.value
            : allCompanies?.find(c => c.id === id)?.name) || '';
    };
    const defaultFormData: AddCreateLegalCaseFormData = {
        file: null,
        name: legalCase?.name || "",
        fileNumber: legalCase?.fileNumber || "",
        corporateFileNumber: legalCase?.corporateFileNumber || "",
        investigationDate: "",
        prosecutors: legalCase?.prosecutors.map(p => ({
            companyId: p.company?.id || null,
            clientId: p.client?.id || null,
            name: getLitigantName(
                p.company?.id || p.client?.id || 0,
                p.type
            ),
            type: p.type
        })) || [],
        defendants: legalCase?.defendants.map(d => ({
            companyId: d.company?.id || null,
            clientId: d.client?.id || null,
            name: getLitigantName(
                d.company?.id || d.client?.id || 0,
                d.type
            ),
            type: d.type
        })) || [],
        reportedEntities: legalCase?.reportedEntities.map(e => ({
            companyId: e.company?.id || null,
            clientId: e.client?.id || null,
            name: getLitigantName(
                e.company?.id || e.client?.id || 0,
                e.type
            ),
            type: e.type
        })) || [],
        caseDate: legalCase?.caseDate
            ? moment.unix(legalCase.caseDate).toDate()
            : new Date(),
        cityId: cityHolder?.city.plateId || null,
        courtHouseId: legalCase?.court?.courtHouse.id || null,
        caseType: legalCase?.type || CaseType.Hukuk,
        status: legalCase?.status || LegalCaseStatus.Acik,
        courtId: legalCase?.court?.id || null,
        committeeId: legalCase?.committee?.id || null,
        notaryId: legalCase?.notary?.id || null,
        trialDates: legalCase?.trialDates.map((date) => moment.unix(date).format("YYYY-MM-DDTHH:mm:ss")) || [],
        appeal: legalCase?.appeal || null,
        note: null,
        responsibleIds: legalCase?.responsibles.map((it) => it.id) || [],
        amount: legalCase?.amount || 0,
        currencyType: legalCase?.currencyType || CurrencyType.TL,
    };

    const [formData, setFormData] = useState<AddCreateLegalCaseFormData>(defaultFormData);
    const [prosecutorsChipData, setProsecutorsChipData] = React.useState<readonly ExtendedChipData[]>([]);

    const [defendantsChipData, setDefendantsChipData] = React.useState<readonly ExtendedChipData[]>([]);

    const [reportedEntitiesChipData, setReportedEntitiesChipData] = React.useState<readonly ExtendedChipData[]>([]);
    const [responsibleIds, setResponsibleIds] = useState<number[]>([]);

    const setLegalCaseFileName = (fileName: string | null) => {
        setFormData({
            ...formData, file: fileName
        });
    }

    const handleChangeFormData = (event: any) => {
        const {name, value, type, checked} = event.target;

        if (type === 'checkbox') {
            setFormData({
                ...formData,
                [name]: checked
            });
        } else if (type === 'select-multiple') {
            setFormData({
                ...formData,
                // @ts-ignore
                [name]: Array.from(event.target.selectedOptions, (option) => option.value)
            });
        } else {
            let sideEffects = {};
            if (name === "cityId") {
                sideEffects = {
                    courtId: null,
                    courtHouseId: null
                };
            }
            if (name === "courtHouseId") {
                sideEffects = {
                    courtId: null
                };
            }
            setFormData({
                ...formData,
                [name]: value,
                ...sideEffects
            });
        }
    };

    const handleDateChange = (name: any) => (newDate: any) => {
        if (name === 'trialDates' && newDate) {
            setFormData((prevFormData: any) => ({
                ...prevFormData,
                [name]: [...prevFormData[name], newDate]
            }));
            setTrialDatesChipData((chips) => [
                ...chips,
                {id: new Date().toISOString(), value: moment(newDate).format("YYYY-MM-DD HH:mm:ss")}
            ]);
        } else {
            setFormData((prevFormData: any) => ({
                ...prevFormData,
                [name]: newDate
            }));
        }
    };

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const newErrors: FieldErrors = {};

        if (!formData.caseDate) {
            newErrors.caseDate = "Dava tarihi zorunludur.";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }


        const submitFormData = new FormData();

        try {
            let result: any;
            if (editMode) {
                const metadata: EditLegalCaseDTO = {
                    name: formData.name,
                    prosecutorIds: formData.prosecutors,
                    defendantIds: formData.defendants,
                    reportedEntityIds: formData.reportedEntities,
                    courtId: formData.courtId!!,
                    type: caseType,
                    fileNumber: formData.fileNumber,
                    corporateFileNumber: formData.corporateFileNumber,
                    caseDate: moment(formData.caseDate).unix(),
                    investigationDate: formData.investigationDate,
                    litigationType: null,
                    trialDates: formData.trialDates.map((it: any) => moment(it).unix()),
                    relatedCaseIds: [],
                    appeal: formData.appeal,
                    responsibleIds,
                    notaryId: formData.notaryId,
                    committeeId: formData.committeeId,
                    amount: formData.amount,
                    currencyType: formData.currencyType
                };
                result = await dispatch(editLegalCaseAction({id: legalCase?.id, dto: metadata}));
            } else {
                const metadata: AddLegalCaseDTO = {
                    name: formData.name,
                    prosecutorIds: formData.prosecutors,
                    defendantIds: formData.defendants,
                    reportedEntityIds: formData.reportedEntities,
                    courtId: formData.courtId!!,
                    type: caseType,
                    fileNumber: formData.fileNumber,
                    corporateFileNumber: formData.corporateFileNumber,
                    caseDate: moment(formData.caseDate).unix(),
                    investigationDate: formData.investigationDate,
                    litigationType: null,
                    trialDates: formData.trialDates.map((it: any) => moment(it).unix()),
                    relatedCaseIds: [],
                    note: formData.note || null,
                    appeal: formData.appeal,
                    responsibleIds,
                    notaryId: formData.notaryId,
                    committeeId: formData.committeeId,
                    amount: formData.amount,
                    currencyType: formData.currencyType
                };
                submitFormData.append("file", new FormData(event.currentTarget).get('file') as any);
                submitFormData.append("metadata", new Blob([JSON.stringify(metadata)], {type: "application/json"}));
                result = await dispatch(createLegalCaseAction(submitFormData));
            }

            if (result.type.endsWith("/fulfilled")) {
                onAddLegalCase();
                handleClose();
                if (page === 1) {
                    const isAdminOrManager = user && [UserRole.Admin, UserRole.Manager].includes(user.role) || false;
                    dispatch(getLegalCasesAction({
                        companyIdFilter: null,
                        clientIdFilter: null,
                        nameFilter: null,
                        typeFilter: caseType,
                        courtIdFilter: null,
                        statusFilter: null,
                        courtHouseFilter: null,
                        fileNumberFilter: null,
                        responsibleIdFilter: isAdminOrManager ? null : user?.id,
                        page: 1,
                    }));
                } else {
                    navigate("");
                }
            }
        } catch (error) {
            console.error("Form gönderiminde bir hata oluştu:", error);
        }
    };

    interface ChipData {
        value: string;
        id: string | number;
    }

    interface ExtendedChipData extends ChipData {
        type: LitigantType;
    }

    const ListItem = styled('li')(({theme}) => ({
        margin: theme.spacing(0.5),
    }));

    const handleDeleteProsecutorsChipData = (chipToDelete: ExtendedChipData) => () => {
        setFormData((prevFormData: any) => ({
            ...prevFormData,
            prosecutors: prevFormData.prosecutors.filter((prosecutor: any) => {
                    if (prosecutor.type === chipToDelete.type) {
                        if (chipToDelete.type === LitigantType.Client && prosecutor.clientId === chipToDelete.id) {
                            return false;
                        } else if (chipToDelete.type === LitigantType.Company && prosecutor.companyId === chipToDelete.id) {
                            return false;
                        }
                    }
                    return true;
                }
            ),
        }));
        setProsecutorsChipData((chips) => chips.filter((chip) =>
            chip.id !== chipToDelete.id || chip.type !== chipToDelete.type));
    };

    const handleDeleteDefendantsChipData = (chipToDelete: ExtendedChipData) => () => {
        setFormData((prevFormData: any) => ({
            ...prevFormData,
            defendants: prevFormData.defendants.filter((prosecutor: any) => {
                    if (prosecutor.type === chipToDelete.type) {
                        if (chipToDelete.type === LitigantType.Client && prosecutor.clientId === chipToDelete.id) {
                            return false;
                        } else if (chipToDelete.type === LitigantType.Company && prosecutor.companyId === chipToDelete.id) {
                            return false;
                        }
                    }
                    return true;
                }
            ),
        }));
        setDefendantsChipData((chips) => chips.filter((chip) => chip.id !== chipToDelete.id || chip.type !== chipToDelete.type));
    };

    const handleDeleteReportedEntitiesChipData = (chipToDelete: ExtendedChipData) => () => {
        setFormData((prevFormData: any) => ({
            ...prevFormData,
            reportedEntities: prevFormData.reportedEntities.filter((prosecutor: any) => {
                    if (prosecutor.type === chipToDelete.type) {
                        if (chipToDelete.type === LitigantType.Client && prosecutor.clientId === chipToDelete.id) {
                            return false;
                        } else if (chipToDelete.type === LitigantType.Company && prosecutor.companyId === chipToDelete.id) {
                            return false;
                        }
                    }
                    return true;
                }
            ),
        }));
        setReportedEntitiesChipData((chips) => chips.filter((chip) => chip.id !== chipToDelete.id || chip.type !== chipToDelete.type));
    };

    const handleDeleteTrialDateChipData = (chipToDelete: ChipData) => () => {
        setFormData((prevFormData: any) => ({
            ...prevFormData,
            trialDates: prevFormData.trialDates.filter((trialDate: any) => {
                return moment(trialDate).format("YYYY-MM-DDTHH:mm:ss") !== chipToDelete.value;
            })
        }));
        setTrialDatesChipData((chips) => chips.filter((chip) => chip.id !== chipToDelete.id));
    };

    const addProsecutor = (result: AddLitigantType) => {
        const prosecutorName = result.litigantType === LitigantType.Company
            ? (result.selection as CompanyDTO).name
            : (result.selection as SettingsLookupDTO).value;

        setFormData((formData: any) => ({
            ...formData,
            prosecutors: [
                ...formData.prosecutors,
                {
                    companyId: result.litigantType === LitigantType.Company ? (result.selection as CompanyDTO).id : null,
                    clientId: result.litigantType === LitigantType.Client ? (result.selection as SettingsLookupDTO).id : null,
                    name: prosecutorName,
                    type: result.litigantType
                } as AddLitigantToCaseDTO
            ]
        }));

        setProsecutorsChipData((chips) => [
            ...chips,
            {
                id: [LitigantType.Client, LitigantType.Company].includes(result.litigantType)
                    ? (result.selection as CompanyDTO | SettingsLookupDTO).id
                    : uuidv4(),
                value: prosecutorName,
                type: result.litigantType
            }
        ]);
    }

    const addDefendant = (result: AddLitigantType) => {
        const defendantName = result.litigantType === LitigantType.Company
            ? (result.selection as CompanyDTO).name
            : (result.selection as SettingsLookupDTO).value;

        setFormData((formData: any) => ({
            ...formData,
            defendants: [
                ...formData.defendants,
                {
                    companyId: result.litigantType === LitigantType.Company ? (result.selection as CompanyDTO).id : null,
                    clientId: result.litigantType === LitigantType.Client ? (result.selection as SettingsLookupDTO).id : null,
                    name: defendantName,
                    type: result.litigantType
                } as AddLitigantToCaseDTO
            ]
        }));

        setDefendantsChipData((chips) => [
            ...chips,
            {
                id: [LitigantType.Client, LitigantType.Company].includes(result.litigantType)
                    ? (result.selection as CompanyDTO | SettingsLookupDTO).id
                    : uuidv4(),
                value: defendantName,
                type: result.litigantType
            }
        ]);
    }

    const addTrialDate = (result: any) => {
        setFormData((formData: any) => ({
            ...formData,
            trialDates: [...formData.trialDates, result]
        }));

        setTrialDatesChipData((chips) => [...chips, {
            id: uuidv4(),
            value: result
        }]);
    }

    const addReportedEntity = (result: AddLitigantType) => {
        const reportedEntityName = result.litigantType === LitigantType.Company
            ? (result.selection as CompanyDTO).name
            : (result.selection as SettingsLookupDTO).value;

        setFormData((formData: any) => ({
            ...formData,
            reportedEntities: [
                ...formData.reportedEntities,
                {
                    companyId: result.litigantType === LitigantType.Company ? (result.selection as CompanyDTO).id : null,
                    clientId: result.litigantType === LitigantType.Client ? (result.selection as SettingsLookupDTO).id : null,
                    name: reportedEntityName,
                    type: result.litigantType
                } as AddLitigantToCaseDTO
            ]
        }));

        setReportedEntitiesChipData((chips) => [
            ...chips,
            {
                id: [LitigantType.Client, LitigantType.Company].includes(result.litigantType)
                    ? (result.selection as CompanyDTO | SettingsLookupDTO).id
                    : uuidv4(),
                value: reportedEntityName,
                type: result.litigantType
            }
        ]);
    }

    let title = editMode ? "Hukuk Davası Düzenle" : "Hukuk Davası Ekle";
    let prosecutorsLabel = "Davacılar *";
    let reportedEntitiesVisible = true;
    let defendantsLabel = "Davalılar *";
    let fileNumberLabel;
    let privateFileLabel = "Dosya Özel Numarası"
    let caseDateLabel
    let trialDatesVisible = true;

    switch (caseType) {
        case CaseType.Ceza: //ceza davaları
            title = "Ceza Davası Ekle";
            title = editMode ? "Ceza Davası Düzenle" : "Ceza Davası Ekle";
            prosecutorsLabel = "Müştekiler/Katılanlar *";
            reportedEntitiesVisible = false;
            defendantsLabel = "Sanıklar *"
            fileNumberLabel = "Dosya Numarası"
            caseDateLabel = "Şikayet Tarihi"
            trialDatesVisible = true
            break;
        case CaseType.Icra: //icra davaları
            title = editMode ? "İcra Davası Düzenle" : "İcra Davası Ekle";
            prosecutorsLabel = "Alacaklılar *";
            reportedEntitiesVisible = false;
            defendantsLabel = "Borçlular *"
            fileNumberLabel = "Dosya Numarası"
            caseDateLabel = "Takip Tarihi"
            trialDatesVisible = false
            break;
        case CaseType.Idari: //İdari davalar
            title = editMode ? "İdari Dava Düzenle" : "İdari Dava Ekle";
            prosecutorsLabel = "Davacılar *";
            reportedEntitiesVisible = true;
            defendantsLabel = "Davalılar *"
            fileNumberLabel = "Dosya Numarası"
            caseDateLabel = "Dava Tarihi *"
            trialDatesVisible = true
            break;
        case CaseType.Sorusturma: //soruşturmalar
            title = editMode ? "Soruşturma Düzenle" : "Soruşturma Ekle";
            prosecutorsLabel = "Müşteki *";
            reportedEntitiesVisible = false;
            defendantsLabel = "Şüpheli *";
            fileNumberLabel = "Soruşturma Numarası"
            caseDateLabel = "Şikayet Tarihi"
            trialDatesVisible = false
            break;
        case CaseType.TuketiciHakemHeyeti:
            title = editMode ? "Tüketici Hakem Heyeti Davası Düzenle" : "Tüketici Hakem Heyeti Davası Ekle";
            prosecutorsLabel = "Davacılar *";
            reportedEntitiesVisible = false;
            defendantsLabel = "Davalılar *";
            fileNumberLabel = "Tüketici Hakem Heyeti Numarası"
            caseDateLabel = "Şikayet Tarihi"
            trialDatesVisible = false
            break;
        case CaseType.Ihtarname:
            title = editMode ? "İhtarname Davası Düzenle" : "İhtarname Davası Ekle";
            prosecutorsLabel = "Davacılar *";
            reportedEntitiesVisible = false;
            defendantsLabel = "Davalılar *";
            fileNumberLabel = "İhtarname Numarası"
            caseDateLabel = "Şikayet Tarihi"
            trialDatesVisible = false
            break;
        case CaseType.IcraTakip:
            title = editMode ? "İcra Takipleri Davası Düzenle" : "İcra Takipleri Davası Ekle";
            prosecutorsLabel = "Davacılar *";
            reportedEntitiesVisible = false;
            defendantsLabel = "Davalılar *";
            fileNumberLabel = "İcra Takip Numarası"
            caseDateLabel = "Şikayet Tarihi"
            trialDatesVisible = false
            break;
        default:
            fileNumberLabel = "Dosya Numarası";
            caseDateLabel = "Dava Tarihi *";
            break;
    }

    const [errors, setErrors] = useState<FieldErrors>({});

    const shouldShowCourtFields = ![CaseType.TuketiciHakemHeyeti, CaseType.Ihtarname, CaseType.IcraTakip].includes(caseType);

    useEffect(() => {
        if (createLegalCaseTaskStatus?.fieldErrors) {
            const updatedErrors: FieldErrors = {};
            createLegalCaseTaskStatus?.fieldErrors.forEach((it) =>
                updatedErrors[it.field] = it.message);
            setErrors(updatedErrors);
        }
    }, [createLegalCaseTaskStatus]);

    useEffect(() => {
        if (formData.caseDate) {
            setErrors((prevErrors) => {
                const {caseDate, ...rest} = prevErrors;
                return rest;
            });
        } else {
            setErrors((prevErrors) => ({
                ...prevErrors,
                caseDate: "Dava tarihi zorunludur.",
            }));
        }
    }, [formData.caseDate]);

    useEffect(() => {
        if (legalCase && allClientsLookup && allCompanies && editMode) {
            const prosecutorChips = legalCase.prosecutors.map(prosecutor => ({
                id: prosecutor.company?.id || prosecutor.client?.id || uuidv4(),
                value: getLitigantName(
                    prosecutor.company?.id || prosecutor.client?.id || 0,
                    prosecutor.type
                ), type: prosecutor.type
            }));
            setProsecutorsChipData(prosecutorChips);

            const defendantChips = legalCase.defendants.map(defendant => ({
                id: defendant.company?.id || defendant.client?.id || uuidv4(),
                value: getLitigantName(
                    defendant.company?.id || defendant.client?.id || 0,
                    defendant.type
                ),
                type: defendant.type
            }));
            setDefendantsChipData(defendantChips);

            const reportedChips = legalCase.reportedEntities.map(entity => ({
                id: entity.company?.id || entity.client?.id || uuidv4(),
                value: getLitigantName(
                    entity.company?.id || entity.client?.id || 0,
                    entity.type
                ),
                type: entity.type
            }));
            setReportedEntitiesChipData(reportedChips);

            const trialChips = legalCase.trialDates.map((date) => ({
                id: uuidv4(),
                value: moment.unix(date).format("YYYY-MM-DDTHH:mm:ss")
            }));
            setTrialDatesChipData(trialChips);

            setResponsibleIds(legalCase.responsibles.map((it) => it.id));

            setFormData((prevFormData) => ({
                ...prevFormData,
                name: legalCase.name,
                fileNumber: legalCase.fileNumber,
                caseType: legalCase.type,
                caseDate: legalCase.caseDate
                    ? moment.unix(legalCase.caseDate).toDate()
                    : new Date(),
                corporateFileNumber: legalCase.corporateFileNumber,
                cityId: cityHolder?.city.plateId || null,
                courtHouseId: legalCase.court?.courtHouse.id || null,
                courtId: legalCase.court?.id || null,
                committeeId: legalCase.committee?.id || null,
                notaryId: legalCase.notary?.id || null,
                prosecutors: legalCase.prosecutors.map(p => ({
                    companyId: p.company?.id || null,
                    clientId: p.client?.id || null,
                    name: getLitigantName(
                        p.company?.id || p.client?.id || 0,
                        p.type
                    ),
                    type: p.type
                })),
                defendants: legalCase.defendants.map(d => ({
                    companyId: d.company?.id || null,
                    clientId: d.client?.id || null,
                    name: getLitigantName(
                        d.company?.id || d.client?.id || 0,
                        d.type
                    ),
                    type: d.type
                })),
                status: legalCase.status,
                reportedEntities: legalCase.reportedEntities.map(e => ({
                    companyId: e.company?.id || null,
                    clientId: e.client?.id || null,
                    name: getLitigantName(
                        e.company?.id || e.client?.id || 0,
                        e.type
                    ),
                    type: e.type
                })),
                trialDates: legalCase.trialDates.map((date) => moment.unix(date).format("YYYY-MM-DDTHH:mm:ss"))
            }));

            setSelectedCourt(legalCase.court?.id || null);
            setSelectedCommittee(legalCase.committee?.id || null);
            setSelectedNotary(legalCase.notary?.id || null);
        }
    }, [legalCase, allClientsLookup, allCompanies, editMode]);

    const excludedItems = [
        ...formData.prosecutors,
        ...formData.defendants,
        ...formData.reportedEntities
    ]

    const isCourtTypeEqualCaseType = (courtType: CourtType) => {
        switch (caseType) {
            case CaseType.Idari:
                return [CourtType.IdareMahkemeleri, CourtType.VergiMahkemeleri].includes(courtType);
            case CaseType.Hukuk:
                return courtType === CourtType.HukukMahkemeleri;
            case CaseType.Icra:
                return courtType === CourtType.IcraMahkemeleri;
            case CaseType.Ceza:
                return courtType === CourtType.CezaMahkemeleri;
            case CaseType.Sorusturma:
                return courtType === CourtType.Savcilik;
            case CaseType.IcraTakip:
                return courtType === CourtType.IcraDaireleri;
        }
    }

    const cityOptions = allCitiesLookup?.map((city) => ({
        value: city.id,
        label: city.value,
    })) || [];

    const courtHouseOptions = allCourtHouses?.filter(courtHouse => courtHouse.city.plateId === formData.cityId)
        .map((courtHouse) => ({
            value: courtHouse.id,
            label: courtHouse.name,
        })) || [];

    const filteredCourtsByCaseType = allCourts?.filter(court =>
        court.courtHouse.id === formData.courtHouseId && isCourtTypeEqualCaseType(court.type)
    ).map(court => ({
        value: court.id,
        label: court.name
    })) || []

    const idareLabel = "İdare Mahkemeleri";
    const vergiLabel = "Vergi Mahkemeleri";

    const courtOptions =
        caseType === CaseType.Idari
            ? [
                {value: -1, label: "Yeni Kayıt", group: idareLabel, isNew: true},
                ...filteredCourtsByCaseType
                    .filter((court) =>
                        (allCourts || []).some(
                            (c) => c.id === court.value && c.type === CourtType.IdareMahkemeleri
                        )
                    )
                    .map((court) => ({...court, group: idareLabel})),
                {value: -2, label: "Yeni Kayıt", group: vergiLabel, isNew: true},
                ...filteredCourtsByCaseType
                    .filter((court) =>
                        (allCourts || []).some(
                            (c) => c.id === court.value && c.type === CourtType.VergiMahkemeleri
                        )
                    )
                    .map((court) => ({...court, group: vergiLabel})),
            ]
            : [
                {value: -1, label: "Yeni Kayıt", isNew: true},
                ...filteredCourtsByCaseType,
            ];


    const [selectedCommittee, setSelectedCommittee] = useState<number | null>(null);

    const committeeOptions = [
        {
            value: -1,
            label: "Yeni Kayıt"
        },
        ...allCommittees?.filter(committee => committee.city.plateId === formData.cityId)
            .map((committee) => ({
                value: committee.id,
                label: committee.name,
            })) || []];

    const [selectedNotary, setSelectedNotary] = useState<number | null>(null);

    const notaryOptions = [
        {
            value: -1,
            label: "Yeni Kayıt"
        },
        ...allNotaries?.filter(notary => notary.city.plateId === formData.cityId)
            .map((notary) => ({
                value: notary.id,
                label: notary.name,
            })) || []];

    const executiveFollowUpCourtOptions = [
        {value: -1, label: "Yeni Kayıt"},
        ...allCourts?.filter((court) => court.courtHouse.city.plateId === formData.cityId && court.type === CourtType.IcraDaireleri)
            .map((court) => ({
                value: court.id,
                label: court.name,
            })) || []
    ];

    return (
        <>
            <CustomDialog
                open={true}
                onClose={handleClose}
                PaperProps={{
                    component: 'form',
                    onSubmit: handleSubmit
                }}>
                <DialogTitle>{title}</DialogTitle>
                <DialogContent>
                    <FormControl fullWidth={true} sx={{mb: 1}}>
                        <TextField
                            value={formData.name}
                            required
                            autoFocus
                            margin="dense"
                            id="name"
                            name="name"
                            label="Konu"
                            type="text"
                            fullWidth
                            variant={fieldVariant as TextFieldVariants}
                            onChange={handleChangeFormData}/>
                        {errors.name && (
                            <ErrorText message={errors.name}/>
                        )}
                    </FormControl>

                    <FormControl fullWidth={true} sx={{mt: 2, mb: 1}}>
                        <InputLabel id="prosecutors-id-label">
                            {prosecutorsLabel}
                        </InputLabel>

                        <OutlinedInput
                            required
                            label={prosecutorsLabel}
                            id='prosecutors'
                            inputProps={{
                                style: {
                                    position: "absolute",
                                    opacity: 0,
                                    pointerEvents: "none"
                                },
                                value: prosecutorsChipData
                            }}
                            startAdornment={
                                <div
                                    style={{
                                        marginTop: "10px",
                                        marginBottom: "10px",
                                        flex: 1,
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        listStyle: 'none',
                                    }}>
                                    {prosecutorsChipData.map((data) => (
                                        <ListItem key={data.id}>
                                            <Chip label={data.value}
                                                  sx={{
                                                      height: 24,
                                                      fontSize: '0.75rem',
                                                      '& .MuiChip-label': {fontWeight: 500}
                                                  }}
                                                  onDelete={handleDeleteProsecutorsChipData(data)}/>
                                        </ListItem>
                                    ))}
                                </div>
                            }
                            endAdornment={
                                <div style={{
                                    marginTop: "12px",
                                    marginBottom: "12px",
                                }}>
                                    <Fab size="small" sx={{marginLeft: "auto"}}
                                         color="primary" aria-label="add" onClick={handleAddProsecutorDialogOpen}>
                                        <AddIcon/>
                                    </Fab>
                                </div>
                            }/>
                        {errors.prosecutorIds && (
                            <ErrorText message={errors.prosecutorIds}/>
                        )}
                    </FormControl>
                    <FormControl fullWidth={true} sx={{mt: 2, mb: 1}}>
                        <InputLabel id="defandants-id-label">
                            {defendantsLabel}
                        </InputLabel>

                        <OutlinedInput
                            required
                            label='Davacılar *'
                            id='defendants'
                            inputProps={{
                                style: {
                                    position: "absolute",
                                    opacity: 0,
                                    pointerEvents: "none"
                                },
                                value: defendantsChipData
                            }}
                            startAdornment={
                                <div
                                    style={{
                                        marginTop: "10px",
                                        marginBottom: "10px",
                                        flex: 1,
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        listStyle: 'none',
                                    }}>
                                    {defendantsChipData.map((data) => (
                                        <ListItem key={data.id}>
                                            <Chip label={data.value}
                                                  sx={{
                                                      height: 24,
                                                      fontSize: '0.75rem',
                                                      '& .MuiChip-label': {fontWeight: 500}
                                                  }}
                                                  onDelete={handleDeleteDefendantsChipData(data)}/>
                                        </ListItem>
                                    ))}
                                </div>
                            }
                            endAdornment={
                                <div style={{
                                    marginTop: "12px",
                                    marginBottom: "12px",
                                }}>
                                    <Fab size="small" sx={{marginLeft: "auto"}}
                                         color="primary" aria-label="add" onClick={handleAddDefendantsDialogOpen}>
                                        <AddIcon/>
                                    </Fab>
                                </div>
                            }/>
                        {errors.defendantIds && (
                            <ErrorText message={errors.defendantIds}/>
                        )}
                    </FormControl>

                    {reportedEntitiesVisible && (
                        <FormControl fullWidth={true} sx={{mt: 2, mb: 1}}>
                            <InputLabel id="reportedEntities-id-label">
                                İhbar Olunanlar
                            </InputLabel>
                            <OutlinedInput
                                label="İhbar Olunanlar"
                                id="reportedEntities"
                                inputProps={{
                                    style: {
                                        position: "absolute",
                                        opacity: 0,
                                        pointerEvents: "none"
                                    },
                                    value: reportedEntitiesChipData
                                }}
                                startAdornment={
                                    <div
                                        style={{
                                            marginTop: "10px",
                                            marginBottom: "10px",
                                            flex: 1,
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            listStyle: 'none',
                                        }}>
                                        {reportedEntitiesChipData.map((data) => (
                                            <ListItem key={data.id}>
                                                <Chip label={data.value}
                                                      sx={{
                                                          height: 24,
                                                          fontSize: '0.75rem',
                                                          '& .MuiChip-label': {fontWeight: 500}
                                                      }}
                                                      onDelete={handleDeleteReportedEntitiesChipData(data)}/>
                                            </ListItem>
                                        ))}
                                    </div>
                                }
                                endAdornment={
                                    <div style={{
                                        marginTop: "12px",
                                        marginBottom: "12px",
                                    }}>
                                        <Fab size="small" sx={{marginLeft: "auto"}}
                                             color="primary" aria-label="add"
                                             onClick={handleAddReportedEntitiesDialogOpen}>
                                            <AddIcon/>
                                        </Fab>
                                    </div>
                                }/>
                            {errors.reportedEntityIds && (
                                <ErrorText message={errors.reportedEntityIds}/>
                            )}
                        </FormControl>
                    )}

                    <FormControl fullWidth={true} sx={{mt: 2, mb: 1}}>
                        <Autocomplete
                            onChange={(_, newValue) => {
                                setFormData({
                                    ...formData,
                                    cityId: newValue?.value || null,
                                    courtHouseId: null,
                                    courtId: null
                                });
                                setSelectedNotary(null);
                                setSelectedCommittee(null);
                            }}
                            options={cityOptions}
                            value={cityOptions.find((opt) => opt.value === formData.cityId) || null}
                            renderInput={(params) =>
                                <TextField {...params}
                                           label="Şehirler"
                                           value={formData.cityId}
                                           variant="outlined"
                                           required/>
                            }/>
                    </FormControl>

                    {caseType === CaseType.TuketiciHakemHeyeti && (
                        <FormControl fullWidth={true} sx={{mt: 2, mb: 1}}>
                            <Autocomplete
                                onChange={(_, newValue) => {
                                    if (newValue?.value === -1) {
                                        handleCreateCommitteeDialogOpen()
                                    } else {
                                        setSelectedCommittee(newValue?.value || null);
                                        setFormData({
                                            ...formData,
                                            committeeId: newValue?.value || null,
                                        });
                                    }
                                }}
                                options={committeeOptions}
                                value={committeeOptions.find((opt) => opt.value === selectedCommittee) || null}
                                renderInput={(params) =>
                                    <TextField {...params}
                                               label="Tüketici Hakem Heyetleri"
                                               variant="outlined"
                                               value={formData.committeeId}
                                               required/>}
                                disabled={!formData.cityId}/>
                        </FormControl>
                    )}

                    {caseType === CaseType.Ihtarname && (
                        <FormControl fullWidth={true} sx={{mt: 2, mb: 1}}>
                            <Autocomplete
                                onChange={(_, newValue) => {
                                    if (newValue?.value === -1) {
                                        handleCreateNotaryDialogOpen()
                                    } else {
                                        setSelectedNotary(newValue?.value || null);
                                        setFormData({
                                            ...formData,
                                            notaryId: newValue?.value || null,
                                        });
                                    }
                                }}
                                options={notaryOptions}
                                value={notaryOptions.find((opt) => opt.value === selectedNotary) || null}
                                renderInput={(params) =>
                                    <TextField {...params}
                                               label="Noterler"
                                               value={formData.notaryId}
                                               variant="outlined"
                                               required/>}
                                disabled={!formData.cityId}/>
                        </FormControl>
                    )}

                    {caseType === CaseType.IcraTakip && (
                        <>
                            <FormControl fullWidth={true} sx={{mt: 2, mb: 1}}>
                                <Autocomplete
                                    onChange={(_, newValue) => {
                                        setFormData({
                                            ...formData,
                                            courtHouseId: newValue?.value || null,
                                            courtId: null,
                                        });
                                    }}
                                    options={courtHouseOptions}
                                    value={courtHouseOptions.find((opt) => opt.value === formData.courtHouseId) || null}
                                    renderInput={(params) =>
                                        <TextField {...params}
                                                   label="Adliyeler"
                                                   value={formData.courtHouseId}
                                                   variant="outlined"
                                                   required/>}
                                    disabled={!formData.cityId}/>
                            </FormControl>

                            <FormControl fullWidth={true} sx={{mt: 2, mb: 1}}>
                                <Autocomplete
                                    onChange={(_, newValue) => {
                                        if (newValue?.value === -1) {
                                            handleCreateCourtDialogOpen(formData.courtHouseId);
                                        } else {
                                            setFormData({
                                                ...formData,
                                                courtId: newValue?.value || null,
                                            });
                                        }
                                    }}
                                    options={executiveFollowUpCourtOptions}
                                    value={executiveFollowUpCourtOptions.find((opt) => opt.value === formData.courtId) || null}
                                    renderInput={(params) =>
                                        <TextField {...params}
                                                   value={formData.courtId}
                                                   label="İcra Dairesi"
                                                   variant="outlined"
                                                   required/>}
                                    disabled={!formData.cityId}/>
                            </FormControl>
                        </>
                    )}

                    {shouldShowCourtFields && (
                        <>
                            <FormControl fullWidth={true} sx={{mt: 2, mb: 1}}>
                                <Autocomplete
                                    onChange={(_, newValue) => {
                                        setFormData({
                                            ...formData,
                                            courtHouseId: newValue?.value || null,
                                            courtId: null,
                                        });
                                    }}
                                    options={courtHouseOptions}
                                    value={courtHouseOptions.find((opt) => opt.value === formData.courtHouseId) || null}
                                    renderInput={(params) =>
                                        <TextField {...params}
                                                   value={formData.courtHouseId}
                                                   label="Adliyeler"
                                                   variant="outlined"
                                                   required/>}
                                    disabled={!formData.cityId}/>
                            </FormControl>

                            <FormControl fullWidth sx={{mt: 2, mb: 1}}>
                                <Autocomplete
                                    disabled={!formData.courtHouseId}
                                    options={courtOptions}
                                    value={courtOptions.find((opt) => opt.value === formData.courtId) || null}
                                    onChange={(_, newValue) => {
                                        if (newValue?.value && [-1, -2].includes(newValue.value)) {
                                            if (caseType === CaseType.Idari) {
                                                setUsedCourtType(
                                                    newValue.value === -1
                                                        ? CourtType.IdareMahkemeleri
                                                        : CourtType.VergiMahkemeleri
                                                );
                                            }
                                            handleCreateCourtDialogOpen(formData.courtHouseId);
                                        } else {
                                            setFormData({
                                                ...formData,
                                                courtId: newValue?.value || null,
                                            });
                                            setSelectedCourt(newValue?.value || null);
                                        }
                                    }}
                                    groupBy={(option) => (option as any).group || ''}
                                    getOptionLabel={(option) => option.label}
                                    renderGroup={(params) => {
                                        if (!params.group) {
                                            return <ul key={params.key} style={{paddingLeft: 0}}>{params.children}</ul>;
                                        }

                                        return (
                                            <div key={params.key} style={{marginTop: 12}}>
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    padding: '8px 12px',
                                                    borderRadius: 4,
                                                    fontSize: '1.05rem',
                                                    fontWeight: 'bold'
                                                }}>
                                                    {params.group}
                                                </div>
                                                <hr style={{
                                                    border: 'none',
                                                    borderTop: '1.5px solid #e0e0e0',
                                                    margin: '4px 0 8px 0'
                                                }}/>
                                                <ul style={{paddingLeft: 0}}>{params.children}</ul>
                                            </div>
                                        );
                                    }}
                                    renderOption={(props, option) => (
                                        <li
                                            {...props}
                                            style={
                                                (option as any).isNew
                                                    ? {fontStyle: 'normal', color: '#1976d2'}
                                                    : {}
                                            }>
                                            {option.label}
                                        </li>
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={getPresentableCaseTypeCourtName(caseType)}
                                            variant="outlined"
                                            required/>
                                    )}/>
                            </FormControl>
                        </>
                    )}

                    <FormControl fullWidth={true} sx={{mb: 1}}>
                        <TextField
                            value={formData.fileNumber}
                            required
                            margin="dense"
                            id="fileNumber"
                            name="fileNumber"
                            label={fileNumberLabel}
                            type="text"
                            fullWidth
                            variant={fieldVariant as TextFieldVariants}
                            onChange={handleChangeFormData}/>
                        {errors.fileNumber && (
                            <ErrorText message={errors.fileNumber}/>
                        )}
                    </FormControl>
                    <FormControl fullWidth={true} sx={{mb: 1}}>
                        <TextField
                            value={formData.corporateFileNumber}
                            required
                            margin="dense"
                            id="corporateFileNumber"
                            name="corporateFileNumber"
                            label={privateFileLabel}
                            type="text"
                            fullWidth
                            variant={fieldVariant as TextFieldVariants}
                            onChange={handleChangeFormData}/>
                        {errors.corporateFileNumber && (
                            <ErrorText message={errors.corporateFileNumber}/>
                        )}
                    </FormControl>

                    <FormControl fullWidth={true} sx={{mt: 2, mb: 1}}>
                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={tr}>
                            <DatePicker
                                label={caseDateLabel}
                                name="caseDate"
                                value={formData.caseDate}
                                onChange={handleDateChange('caseDate')}
                                // @ts-ignore
                                renderInput={(params: any) => <TextField {...params} fullWidth/>}/>
                        </LocalizationProvider>
                        {errors.caseDate && (
                            <ErrorText message={errors.caseDate}/>
                        )}
                    </FormControl>

                    {trialDatesVisible && (
                        <FormControl fullWidth={true} sx={{mt: 2, mb: 1}}>
                            <InputLabel id="trialDates-id-label">
                                Duruşma Tarihleri
                            </InputLabel>
                            <OutlinedInput
                                label="Duruşma Tarihleri"
                                id='trialDates'
                                inputProps={{
                                    style: {
                                        position: "absolute",
                                        opacity: 0,
                                        pointerEvents: "none"
                                    },
                                    value: trialDatesChipData
                                }}
                                startAdornment={
                                    <div
                                        style={{
                                            marginTop: "10px",
                                            marginBottom: "10px",
                                            flex: 1,
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            listStyle: 'none',
                                        }}>
                                        {trialDatesChipData.map((data) => {
                                            const formattedDate = moment(data.value).format('DD MMMM YYYY');
                                            return (
                                                <ListItem key={data.id}>
                                                    <Chip label={formattedDate}
                                                          sx={{
                                                              height: 24,
                                                              fontSize: '0.75rem',
                                                              '& .MuiChip-label': {fontWeight: 500}
                                                          }}
                                                          onDelete={handleDeleteTrialDateChipData(data)}/>
                                                </ListItem>
                                            );
                                        })}
                                    </div>
                                }
                                endAdornment={
                                    <div style={{
                                        marginTop: "12px",
                                        marginBottom: "12px",
                                    }}>
                                        <Fab size="small" sx={{marginLeft: "auto"}}
                                             color="primary" aria-label="add"
                                             onClick={handleAddTrialDatesDialogOpen}>
                                            <AddIcon/>
                                        </Fab>
                                    </div>
                                }/>

                            {errors.trialDates && (
                                <ErrorText message={errors.trialDates}/>
                            )}
                        </FormControl>
                    )}
                    <FormControl fullWidth={true} sx={{mt: 2, mb: 1}}>
                        <InputLabel id="assignee-ids-label">Sorumlular*</InputLabel>
                        <Select
                            required
                            labelId="responsibleIds-label"
                            id="responsible-ids"
                            name="responsibleIds"
                            label="Sorumlular*"
                            fullWidth
                            multiple={true}
                            variant={fieldVariant as TextFieldVariants}
                            value={responsibleIds}
                            onChange={(event: any) => {
                                setResponsibleIds(event.target.value);
                            }}>
                            {allUsersLookup?.map((responsibleLookup: any) => (
                                <MenuItem key={responsibleLookup.id} value={responsibleLookup.id}>
                                    {responsibleLookup.value}
                                </MenuItem>
                            ))}
                        </Select>
                        {errors.responsibleIds && (
                            <ErrorText message={errors.responsibleIds}/>
                        )}
                    </FormControl>
                    <FormControl fullWidth sx={{mb: 1}}>
                        <TextField
                            value={formData.amount}
                            required
                            margin="dense"
                            id="amount"
                            name="amount"
                            label="Tutar"
                            type="number"
                            fullWidth
                            variant={fieldVariant as TextFieldVariants}
                            inputProps={{
                                step: "0.001",
                                min: 0,
                                maxLength: 21
                            }}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d{0,17}(\.\d{0,3})?$/.test(value)) {
                                    handleChangeFormData(e);
                                }
                            }}/>
                        {errors.amount && (
                            <ErrorText message={errors.amount}/>
                        )}
                    </FormControl>
                    <FormControl fullWidth sx={{mb: 1}}>
                        <InputLabel id="currencyType-label">Para Birimi</InputLabel>
                        <Select
                            labelId="currencyType-label"
                            id="currencyType"
                            name="currencyType"
                            value={formData.currencyType}
                            label="Para Birimi"
                            onChange={handleChangeFormData}
                            required>
                            {Object.values(CurrencyType).map((currency) => (
                                <MenuItem key={currency} value={currency}>
                                    {getPresentableCurrencyType(currency)}
                                </MenuItem>
                            ))}
                        </Select>
                        {errors.currencyType && (
                            <ErrorText message={errors.currencyType}/>
                        )}
                    </FormControl>
                    {!editMode && (
                        <FormControl fullWidth={true} sx={{mt: 2, mb: 1}}>
                            <FileUpload
                                setFileName={setLegalCaseFileName}
                                fieldName="file"
                                value={formData.file}
                                uploadButtonLabel="Evrak Ekle"/>
                            {errors.file && (
                                <ErrorText message={errors.file}/>
                            )}
                        </FormControl>
                    )}
                    {createLegalCaseTaskStatus?.type === AsyncTaskStatusType.Error && createLegalCaseTaskStatus.errorMessage && (
                        <ErrorText type="form" message={createLegalCaseTaskStatus.errorMessage}/>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>İptal</Button>
                    <Button type="submit"
                            disabled={!editMode && !formData.file}>
                        {editMode ? "Güncelle" : "Oluştur"}
                    </Button>
                </DialogActions>
            </CustomDialog>

            {addProsecutorDialogIsOpen && (
                <AddProsecutorDialog excludeItems={excludedItems} handleClose={handleAddProsecutorDialogClose}
                                     caseType={caseType}
                                     addProsecutor={addProsecutor}/>
            )}
            {addDefendantsDialogIsOpen && (
                <AddDefendantsDialog
                    excludeItems={excludedItems}
                    handleClose={handleAddDefendantsDialogClose} addDefendants={addDefendant}/>
            )}
            {addReportedEntitiesDialogIsOpen && (
                <AddReportedEntitiesDialog excludeItems={excludedItems}
                                           handleClose={handleAddReportedEntitiesDialogClose}
                                           addReportedEntities={addReportedEntity}/>
            )}
            {addTrialDatesDialogIsOpen && (
                <AddTrialDateDialog handleClose={handleAddTrialDatesDialogClose}
                                    addTrialDate={addTrialDate}/>
            )}

            {createCommitteeDialogIsOpen && (
                <CreateCommitteeDialog
                    selectedCityId={formData.cityId || undefined}
                    handleClose={handleCreateCommitteeDialogClose}
                    handleCreate={handleCreateCommittee}/>
            )}

            {createNotaryDialogIsOpen && (
                <CreateNotaryDialog
                    selectedCityId={formData.cityId || undefined}
                    handleClose={handleCreateNotaryDialogClose}
                    handleCreate={handleCreateNotary}/>
            )}

            {createCourtDialogIsOpen && (
                <CreateCourt
                    handleClose={handleCreateCourtDialogClose}
                    handleAddCourt={handleAddCourt}
                    selectedCityId={formData.cityId || undefined}
                    courtType={usedCourtType || undefined}
                    courtHouseId={formData.courtHouseId || undefined}
                    {...getCourtDialogProps()}/>
            )}
        </>
    );
}
